import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import styles from 'LearningManager/styles/CustomSetup.module.scss';

interface ConfigureState {
	assignmentName: string;
	certDuration: string;
	certExpirationDate: string;
	assignmentStart: string;
	assignmentStartDate: string;
	dueDate: string;
	dueDateValue: string;
}

interface ConfigureSettingsCardProps {
	configure: ConfigureState;
}

const formatChoice = (value: string) => {
	if (!value) return '-';

	const map: Record<string, string> = {
		'one-year': 'learning.createAssignment.certificateSettings.oneYear',
		custom: 'learning.createAssignment.certificateSettings.customExpiration',
		never: 'learning.createAssignment.certificateSettings.neverExpires',
		immediate: 'learning.createAssignment.certificateSettings.immediate',
		schedule: 'learning.createAssignment.certificateSettings.schedule',
		none: 'learning.createAssignment.certificateSettings.none',
		'one-time-assignment':
			'learning.createAssignment.certificateSettings.oneTimeAssignment',
		'ongoing-assignment':
			'learning.createAssignment.certificateSettings.ongoingAssignment'
	};

	return map[value] ?? value;
};

const formatDate = (value: string) => {
	const parsed = moment(value);
	return parsed.isValid() ? parsed.format('M/DD/YYYY') : value;
};

const displayValue = (
	choice: string,
	isDateChoice: boolean,
	date: string,
	t: (key: string) => string
) => isDateChoice && date ? formatDate(date) : t(formatChoice(choice));

const ConfigureSettingsCard: React.FC<ConfigureSettingsCardProps> = ({
	configure
}) => {
	const { t } = useTranslation();

	return (
		<div className={styles.summaryCard}>
			<div>
				<div className={styles.mutedLabel}>
					{t('learning.createAssignment.certificateSettings.name')}
				</div>
				<div className={styles.summaryValue}>
					{configure.assignmentName || '-'}
				</div>
			</div>

			<div className={styles.summaryGrid}>
				<div>
					<div className={styles.mutedLabel}>
						{t(
							'learning.createAssignment.certificateSettings.certificationDuration'
						)}
					</div>
					<div className={styles.summaryValue}>
						{displayValue(
							configure.certDuration,
							configure.certDuration === 'custom',
							configure.certExpirationDate,
							t
						)}
					</div>
				</div>

				<div>
					<div className={styles.mutedLabel}>
						{t('learning.createAssignment.certificateSettings.assignmentStart')}
					</div>
					<div className={styles.summaryValue}>
						{displayValue(
							configure.assignmentStart,
							configure.assignmentStart === 'schedule',
							configure.assignmentStartDate,
							t
						)}
					</div>
				</div>
				<div>
					<div className={styles.mutedLabel}>
						{t('learning.createAssignment.certificateSettings.dueDate')}
					</div>
					<div className={styles.summaryValue}>
						{displayValue(
							configure.dueDate,
							configure.dueDate === 'custom',
							configure.dueDateValue,
							t
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConfigureSettingsCard;